export function DVLALookupSettingsCtrl (
  $state,
  $scope,
  $translate,
  confirm,
  dvlaLookupApi,
  messages,
  sessionObjAPI
) {
  $scope.loaded   = true;
  $scope.requests = sessionObjAPI.company().dvla_lookup_requests || 0;

  $scope.DVLALookup = dvlaLookupApi;

  $scope.activate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', { name: 'DVLA Lookup' }))
    .then(() => $scope.DVLALookup.activate())
    .then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', { name: 'DVLA Lookup' }), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.deactivate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', { name: 'DVLA Lookup' }))
    .then(() => $scope.DVLALookup.deactivate())
    .then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', { name: 'DVLA Lookup' }), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.purchase = function () {
    $scope.DVLALookup.purchase()
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.PURCHASED_INTEGRATION', { name: 'DVLA Lookup' }), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };
}